export const IntakePrefixes = {
  LocationInformation: 'location-information',
  BusinessInformation: 'business-information',
  PortingInformation: 'porting-information',
  UploadPhoneBill: 'upload-phone-bill',
  Software: 'software-setup',
};
